import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import * as common from 'libs/commonFunc';
import moment from 'moment';

import { Image, Popup } from 'semantic-ui-react';

import { ReduxFormHiddenRecord, ReduxFormMaterialSwitch, ReduxFormSlider } from 'components';

import classNames from 'classnames/bind';
import styles from './SendReserve.css';
const cx = classNames.bind(styles);

class SendReserve extends Component {
  constructor(props) {
    super(props);

    const { sendReservePeriod } = this.props;
    this.state = { periodDay: sendReservePeriod ? sendReservePeriod : 1 };
  }

  onHandlePeriodDay = type => {
    const { sendReserveEnable } = this.props;

    if (sendReserveEnable && Number(sendReserveEnable) === 1) {
      if (type === 'plus') {
        const { sendReservePeriod, examStartDate, examEndDate } = this.props;

        if (
          (common.epochFromDate(examEndDate) - common.epochFromDate(examStartDate)) / 86400 >
          this.state.periodDay + 1
        ) {
          this.setState({ periodDay: this.state.periodDay + 1 });
        }

        // 마이너스는 최소값이 1
      } else if (type === 'minus' && this.state.periodDay > 1) {
        this.setState({ periodDay: this.state.periodDay - 1 });
      }
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      examStartDate,
      examEndDate,
      sendReserveEnable,
      sendReservePeriod,
      sendReserveHour,
      disabledEndStat
    } = this.props;

    // 훈련 메일 나눔 발송
    let sendPeriodText = '';
    if (examStartDate && Number(sendReservePeriod)) {
      if (Number(sendReserveEnable)) {
        const endPeriod = moment(examStartDate).add(Number(sendReservePeriod) - 1, 'days');
        const dateFormat =
          (!examStartDate.isSame(endPeriod, 'year') && 'YYYY.M.D') ||
          (!examStartDate.isSame(endPeriod, 'month') && 'M.D') ||
          'D';
        const endPeriodText = Number(sendReservePeriod) > 1 ? ' ~ ' + endPeriod.format(dateFormat) : '';
        let sendReserveHourText =
          defineMessages(formatMessage({ id: 'StartExamWizardContent_119', defaultMessage: 'Ship' })) +
          defineMessages(formatMessage({ id: 'StartExamWizardContent_116', defaultMessage: 'between' })) +
          sendReserveHour[0] +
          defineMessages(formatMessage({ id: 'StartExamWizardContent_117', defaultMessage: ' ~ ' })) +
          sendReserveHour[1] +
          defineMessages(formatMessage({ id: 'StartExamWizardContent_81', defaultMessage: '시' })) +
          ' ' +
          defineMessages(formatMessage({ id: 'StartExamWizardContent_83', defaultMessage: '사이에 메일 발송' }));
        if (sendReserveHour[0] === sendReserveHour[1]) {
          sendReserveHourText =
            defineMessages(formatMessage({ id: 'StartExamWizardContent_118', defaultMessage: ' ' })) +
            sendReserveHour[0] +
            defineMessages(formatMessage({ id: 'StartExamWizardContent_81', defaultMessage: '시' })) +
            ' ' +
            defineMessages(formatMessage({ id: 'StartExamWizardContent_87', defaultMessage: '에 메일 발송' }));
        }

        sendPeriodText = (
          <div className={cx('sendPeriodText')}>
            {'※ ' +
              moment(examStartDate).format('l') +
              endPeriodText +
              // 날자 표시가 Day일때만 '일'을 뒤에 붙여준다.
              defineMessages(formatMessage({ id: 'LicenseEdit_12', defaultMessage: '일' })) +
              ' ' +
              sendReserveHourText}
          </div>
        );
      }
    }

    return (
      <div
        className={cx('send-reserve-area', {
          disabled: !!disabledEndStat
        })}>
        <div className={cx('isReserve-area')}>
          <div className={cx('display-flex')}>
            <div className={cx('bold')}>
              {defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_82',
                  defaultMessage: '훈련 메일 나눔 발송'
                })
              )}
            </div>
            <Popup
              position="right center"
              trigger={<Image className={cx('ml-5')} src="/img/examStart/btn_qmark.png" />}
              content={ReactHtmlParser(
                defineMessages(
                  formatMessage({
                    id: 'StartExamWizardContent_86',
                    defaultMessage:
                      "<div>훈련 메일을 아래에서 설정한</div><div><b>'발송 기간'</b>과 <b>'발송 시간'</b> 사이에</div><div>발송합니다.</div>"
                  })
                )
              )}
            />
          </div>
          <ReduxFormMaterialSwitch
            className={cx('input-switch')}
            name="sendReserveEnable"
            value={sendReserveEnable ? '1' : '0'}
            checked={!(sendReserveEnable && Number(sendReserveEnable) === 1) ? false : true}
          />
        </div>
        <div
          className={cx('reserve-content', {
            disabled: !(sendReserveEnable && Number(sendReserveEnable) === 1)
          })}>
          <div className={cx('sendReservePeriod-area')}>
            <div className={cx('sendReserve-title mt-2')}>
              {defineMessages(formatMessage({ id: 'StartExam_12', defaultMessage: '나눔 발송 기간 (일)' }))}
            </div>
            <div className={cx('sendReservePeriod-day')}>
              <ReduxFormHiddenRecord
                name="sendReservePeriod"
                validate={sendReserveEnable && Number(sendReserveEnable) === 1 ? ['required', 'minValue1'] : []}
                valuePass={this.state.periodDay}
              />
              <Image
                className={cx('bt-sendReservePeriod-day')}
                src={'/img/examStart/btn_minus.png'}
                onClick={() => {
                  this.onHandlePeriodDay('minus');
                }}
              />
              <span className={cx('sendReservePeriod-day-text')}>{this.state.periodDay}</span>

              {(common.epochFromDate(examEndDate) - common.epochFromDate(examStartDate)) / 86400 >
              this.state.periodDay + 1 ? (
                <Image
                  className={cx('bt-sendReservePeriod-day')}
                  src={'/img/examStart/btn_plus.png'}
                  onClick={() => {
                    this.onHandlePeriodDay('plus');
                  }}
                />
              ) : (
                <Popup
                  trigger={
                    <Image
                      className={cx('bt-sendReservePeriod-day')}
                      src={'/img/examStart/btn_plus.png'}
                      onClick={() => {
                        this.onHandlePeriodDay('plus');
                      }}
                    />
                  }
                  position="top center">
                  {defineMessages(
                    formatMessage({
                      id: 'StartExamWizardContent_84',
                      defaultMessage: '훈련 기간보다 1일 적게 입력하세요'
                    })
                  )}
                </Popup>
              )}
            </div>
          </div>
          <div className={cx('sendReserveHour-area')}>
            <div className={cx('sendReserve-title mb-22')}>
              {defineMessages(formatMessage({ id: 'StartExam_13', defaultMessage: '나눔 발송 시간' }))}
            </div>
            <div className={cx('flex-1')}>
              <div className={cx('sendReserveHour')}>
                <ReduxFormSlider
                  min={0}
                  max={24}
                  step={1}
                  isRange
                  name="sendReserveHour"
                  defaultValue={!!sendReserveHour ? [sendReserveHour[0], sendReserveHour[1]] : [0, 24]}
                  value={!!sendReserveHour ? [sendReserveHour[0], sendReserveHour[1]] : [0, 24]}
                  disabled={!(sendReserveEnable && Number(sendReserveEnable) === 1)}
                />
              </div>
              {sendReserveHour && (
                <div className={cx('sendReserveHour-text')}>
                  <div>
                    {sendReserveHour[0] +
                      defineMessages(formatMessage({ id: 'StartExamWizardContent_81', defaultMessage: '시' }))}
                  </div>
                  <div>
                    {sendReserveHour[1] +
                      defineMessages(formatMessage({ id: 'StartExamWizardContent_81', defaultMessage: '시' }))}
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* 훈련 메일 나눔 발송 */}
          {sendPeriodText}
        </div>
      </div>
    );
  }
}

export default injectIntl(SendReserve);



// WEBPACK FOOTER //
// ./src/script/components/exam-start/SendReserve.js